import { render, staticRenderFns } from "./PDFViewerFull.vue?vue&type=template&id=3c68868b&scoped=true"
import script from "./PDFViewerFull.vue?vue&type=script&lang=js"
export * from "./PDFViewerFull.vue?vue&type=script&lang=js"
import style0 from "./PDFViewerFull.vue?vue&type=style&index=0&id=3c68868b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68868b",
  null
  
)

export default component.exports